import { c as _c } from "react/compiler-runtime";
import React from "react";
import ProductCarousel from "@/features/cake-customization/ProductCarousel";
import { generateProductAltText } from "@/utils/seo";
import ProductAccordion from "@/components/ProductAccordion";
interface ProductGalleryProps {
  product: any;
}
const ProductGallery: React.FC<ProductGalleryProps> = t0 => {
  const $ = _c(14);
  const {
    product
  } = t0;
  const t1 = product?.product_urls;
  let t2;
  if ($[0] !== product?.metadata?.alt_text || $[1] !== product?.metadata?.image_alt || $[2] !== product?.metadata?.vendor_name || $[3] !== product?.name || $[4] !== product?.vendor_details?.business_name) {
    t2 = product?.metadata?.alt_text || product?.metadata?.image_alt || generateProductAltText(product?.name, product?.vendor_details?.business_name || product?.metadata?.vendor_name);
    $[0] = product?.metadata?.alt_text;
    $[1] = product?.metadata?.image_alt;
    $[2] = product?.metadata?.vendor_name;
    $[3] = product?.name;
    $[4] = product?.vendor_details?.business_name;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <ProductCarousel media={t1} altText={t2} />;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== product) {
    t4 = <div className="lg:block hidden w-full"><ProductAccordion product={product} /></div>;
    $[9] = product;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <div className="flex flex-col items-center justify-start w-full lg:max-w-[550px] space-y-6">{t3}{t4}</div>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
export default ProductGallery;